import React, { useState, useEffect, useRef } from "react";
import api from "../../axios";
import { Link } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { RiCloseLine } from "react-icons/ri";
import { AiOutlineMenu } from "react-icons/ai";
import "./navbar.css";
import { get_course_URL, get_image } from "../../helper";

const Navbar = () => {
  const [courses, setCourses] = useState([]);
  const [services, setServices] = useState([]);
  const [books, setBooks] = useState([]);
  const [events, setEvents] = useState([]);
  const [collab, setCollab] = useState([]);
  const [setting, setSetting] = useState({});

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    api.get("/courses").then((response) => {
      setCourses(response.data.data);
    });
    api.get("/events").then((response) => {
      setEvents(response.data.data);
    });
    api.get("/services").then((response) => {
      setServices(response.data.data);
    });
    api.get("/play-books").then((response) => {
      setBooks(response.data.data);
    });
    api.get("/collaborators").then((response) => {
      setCollab(response.data.data);
    });
    api
      .get("/setting", {
        params: {
          populate: "*",
        },
      })
      .then((response) => {
        setSetting(response.data.data.attributes);
      });
  }, []);
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);
  const hasEvents = events.length > 0;
  const hasCourses = courses.length > 0;
  const hasBooks = books.length > 0;
  const hasServices = services.length > 0;
  const hasCollab = collab.length > 0;

  return (
    <div className="navbar">
      <div className="mobile-navbar">
        <div className="logo">
          <Link to="/">
            <img src={get_image(setting.logo)} alt="logo" />
          </Link>
        </div>
        <div className="menu-icon" onClick={handleMenuClick}>
          <AiOutlineMenu size={25} className="menuIcon" />
        </div>
        {isMenuOpen && (
          <div ref={menuRef} className="menu-content scale-up-center">
            <div className="close-icon" onClick={handleMenuClick}>
              <RiCloseLine size={25} />
            </div>
            <div className="menu-container">
              {/* About Us Link */}
              <Accordion>
                <AccordionSummary
                  id="panel1a-header"
                  aria-controls="panel1a-content"
                >
                  <Typography id="heading">
                    <Link
                      onClick={handleMenuClick}
                      style={{ marginBottom: "10px" }}
                      to={"/about-us"}
                    >
                      About Us
                    </Link>
                  </Typography>
                </AccordionSummary>
              </Accordion>
              <div className="separator" />

              {/* Events Accordion - only show if hasEvents */}
              {hasEvents && (
                <>
                  <Accordion>
                    <AccordionSummary
                      id="panel1a-header"
                      aria-controls="panel1a-content"
                    >
                      <Typography id="heading">
                        Events
                        <ExpandMoreIcon />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        marginTop: "-10px",
                      }}
                    >
                      {events.map((event) => (
                        <Link
                          key={event.id}
                          onClick={handleMenuClick}
                          style={{ marginBottom: "10px" }}
                          to={"/events/" + get_course_URL(event)}
                        >
                          {event?.attributes?.title}
                        </Link>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                  <div className="separator" />
                </>
              )}

              {/* Programs Accordion - only show if hasCourses */}
              {hasCourses && (
                <>
                  <Accordion>
                    <AccordionSummary
                      id="panel1a-header"
                      aria-controls="panel1a-content"
                    >
                      <Typography id="heading">
                        Programs
                        <ExpandMoreIcon />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        marginTop: "-10px",
                      }}
                    >
                      {[...courses]
                        .sort((a, b) => a.attributes.rank - b.attributes.rank) // ترتيب تصاعدي
                        .map((course) => (
                          <Link
                            key={course.id}
                            onClick={handleMenuClick}
                            style={{ marginBottom: "10px" }}
                            to={"/courses/" + get_course_URL(course)}
                          >
                            {course?.attributes?.title}
                          </Link>
                        ))}
                    </AccordionDetails>
                  </Accordion>
                  <div className="separator" />
                </>
              )}

              {/* Playbooks Accordion - only show if hasBooks */}
              {hasBooks && (
                <>
                  <Accordion>
                    <AccordionSummary
                      id="panel1a-header"
                      aria-controls="panel1a-content"
                    >
                      <Typography id="heading">
                        Playbooks
                        <ExpandMoreIcon />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        marginTop: "-10px",
                      }}
                    >
                      {books.map((book) => (
                        <Link
                          key={book.id}
                          onClick={handleMenuClick}
                          style={{ marginBottom: "10px" }}
                          to={"/play-books/" + get_course_URL(book)}
                        >
                          {book?.attributes?.title}
                        </Link>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                  <div className="separator" />
                </>
              )}

              {/* Services Accordion - only show if hasServices */}
              {hasServices && (
                <>
                  <Accordion>
                    <AccordionSummary
                      id="panel1a-header"
                      aria-controls="panel1a-content"
                    >
                      <Typography id="heading">
                        Services
                        <ExpandMoreIcon />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        marginTop: "-10px",
                      }}
                    >
                      {services.map((service) => (
                        <Link
                          key={service.id}
                          onClick={handleMenuClick}
                          style={{ marginBottom: "10px" }}
                          to={"/services/" + get_course_URL(service)}
                        >
                          {service?.attributes?.title}
                        </Link>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                  <div className="separator" />
                </>
              )}

              {/* Collaborators Accordion - only show if hasCollab */}
              {hasCollab && (
                <>
                  <Accordion>
                    <AccordionSummary
                      id="panel1a-header"
                      aria-controls="panel1a-content"
                    >
                      <Typography id="heading">
                        Collaborators
                        <ExpandMoreIcon />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        marginTop: "-10px",
                      }}
                    >
                      {collab.map((colab) => (
                        <Link
                          key={colab.id}
                          onClick={handleMenuClick}
                          style={{ marginBottom: "10px" }}
                          to={"/collaborators/" + get_course_URL(colab)}
                        >
                          {colab?.attributes?.title}
                        </Link>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                  <div className="separator" />
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
